export default __webpack_public_path__ + "static/media/EM0140.34I-19954_-14747_0.65867aa8.jpg";